<div class="info-banner">
  <i class="bi bi-info-circle-fill" aria-hidden="true"></i>
  <p>
    Casi <strong>Longevity</strong> che hanno superato una soglia di attenzione e sono stati inviati a un
    Manager, per le persone seguite dai FamilyTutor selezionati, divisi per FamilyTutor. Apri il dettaglio di un caso per
    vederne il punteggio e le risposte; "Chiudi" aggiorna lo stato per tutti.
  </p>
</div>

<!-- ─── Filtri ─────────────────────────────────────────────────────────────── -->
<form class="filters" aria-label="Filtri dei casi Longevity" (submit)="$event.preventDefault()">
  <div class="filter-field filter-wide">
    <label for="lg-search">Cerca</label>
    <input id="lg-search" type="search" name="search" placeholder="N° richiesta"
      [(ngModel)]="filters.search" (ngModelChange)="applyFilters()" />
  </div>

  <div class="filter-field">
    <label for="lg-status">Stato</label>
    <select id="lg-status" name="status" [(ngModel)]="filters.status" (ngModelChange)="onStatusChange()">
      <option value="">Tutti</option>
      <option *ngFor="let status of statuses" [value]="status.id">{{ status.label }}</option>
    </select>
  </div>

  <!-- <div class="filter-field">
    <label for="lg-from">Apertura dal</label>
    <input id="lg-from" type="date" name="from" [(ngModel)]="filters.from" (ngModelChange)="applyFilters()" />
  </div>

  <div class="filter-field">
    <label for="lg-to">Apertura al</label>
    <input id="lg-to" type="date" name="to" [(ngModel)]="filters.to" (ngModelChange)="applyFilters()" />
  </div> -->

  <div class="filter-field">
    <label for="lg-sort">Ordina per</label>
    <select id="lg-sort" name="sort" [(ngModel)]="filters.sort" (ngModelChange)="applyFilters()">
      <option *ngFor="let option of sortOptions" [value]="option.id">{{ option.label }}</option>
    </select>
  </div>

  <!-- <div class="filter-actions">
    <label class="latest-switch">
      <input type="checkbox" name="mineOnly" [(ngModel)]="filters.mineOnly" (ngModelChange)="applyFilters()" />
      <span>Solo i casi che ho preso in carico io</span>
    </label>
    <button type="button" class="btn-reset" [disabled]="activeFilters === 0" (click)="resetFilters()">
      <i class="bi bi-x-circle" aria-hidden="true"></i> Azzera filtri
      <span *ngIf="activeFilters > 0">({{ activeFilters }})</span>
    </button>
  </div> -->
</form>

<!-- ─── Stati ──────────────────────────────────────────────────────────────── -->
<div class="state-message" *ngIf="isLoading" role="status">
  <i class="bi bi-hourglass-split" style="font-size: 40px; opacity: 0.35;" aria-hidden="true"></i>
  <span>Caricamento dei casi Longevity in corso...</span>
</div>

<div class="warning-banner" role="alert" *ngIf="!isLoading && failedOperators.length > 0">
  <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
  <p>
    Non è stato possibile caricare i casi di <strong>{{ failedOperators.join(', ') }}</strong>.
    <button type="button" class="link-btn" (click)="load()">Riprova</button>
  </p>
</div>

<ng-container *ngIf="!isLoading">
  <p class="result-count" aria-live="polite" *ngIf="loadedCount > 0">
    {{ matchingCount }} cas{{ matchingCount === 1 ? 'o' : 'i' }}
    <span *ngIf="matchingCount !== loadedCount">su {{ loadedCount }}</span>
  </p>

  <div class="state-message" *ngIf="loadedCount === 0 && failedOperators.length === 0">
    <i class="bi bi-clipboard-heart" style="font-size: 48px; opacity: 0.2;" aria-hidden="true"></i>
    <p>Nessun caso Longevity per le persone dei FamilyTutor selezionati.</p>
  </div>

  <div class="state-message" *ngIf="loadedCount > 0 && matchingCount === 0">
    <i class="bi bi-funnel" style="font-size: 48px; opacity: 0.2;" aria-hidden="true"></i>
    <p>Nessun caso corrisponde ai filtri selezionati.</p>
  </div>

  <!-- ─── Un blocco per FamilyTutor ────────────────────────────────────────── -->
  <section class="alert-section" *ngFor="let group of groups" [attr.aria-label]="'Casi di ' + group.operator">
    <div class="section-header status-longevity">
      <div class="section-title">
        <i class="bi bi-person-badge-fill" aria-hidden="true"></i>
        <span>{{ group.operator }}</span>
        <span class="threshold-badge" *ngIf="group.open > 0">{{ group.open }} da chiudere</span>
        <span class="threshold-badge" *ngIf="group.takenInCharge > 0">{{ group.takenInCharge }} in carico</span>
      </div>
      <span class="section-count">{{ group.rows.length }} cas{{ group.rows.length === 1 ? 'o' : 'i' }}</span>
    </div>

    <div class="table-wrapper">
      <table>
        <caption class="sr-only">Casi Longevity delle persone seguite da {{ group.operator }}</caption>
        <thead>
          <tr>
            <th scope="col">Stato</th>
            <th scope="col">ID Richiesta</th>
            <th scope="col">Aperto il</th>
            <th scope="col">Chiuso il</th>
            <th scope="col">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let r of visibleRows(group); trackBy: trackByCase">
            <tr class="table-row">
              <td class="nowrap">
                <span class="status-chip" [ngClass]="statusClass(r.status)">{{ statusLabel(r.status) }}</span>
              </td>
              <td class="id-cell">
                <a [href]="'/request-detail/' + r.requestId" target="_blank" rel="noopener" class="id-link">#{{ r.requestId }}</a>
              </td>
              <td class="nowrap">{{ r.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td class="nowrap">{{ r.closedAt ? (r.closedAt | date: 'dd/MM/yyyy HH:mm') : '-' }}</td>
              <td class="actions-cell nowrap">
                <button type="button" class="btn-copy" (click)="openDetail(r)">
                  Dettaglio
                </button>
                <button type="button" class="btn-reset" *ngIf="r.status !== 'CLOSED'"
                  [disabled]="actionPendingId === r.id" (click)="closeCase(r)">
                  Chiudi
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="show-more" *ngIf="hiddenCount(group) > 0">
      <button type="button" class="btn-copy" (click)="showMore(group)">
        Mostra altri {{ hiddenCount(group) > pageSize ? pageSize : hiddenCount(group) }}
        (restanti {{ hiddenCount(group) }})
      </button>
    </div>
  </section>
</ng-container>

<app-longevity-assessment-modal *ngIf="selectedCase" [assessment]="selectedCase"
  (closed)="closeDetail()"></app-longevity-assessment-modal>
